import { useRouter } from 'next/router'
import React, { useCallback, useRef } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import clsx from 'clsx'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarRightAction,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'
import { historyUtils } from '@wartek-id/fe-toolbox'

import { CustomErrorFallback } from 'components/ErrorBoundary'
import { JenjangUnmatched } from 'api/microlearning/useAPITopics'
import PelatihanErrorFallback from 'app/PelatihanMandiriPage/components/PelatihanErrorFallback'
import TopicDetails from 'app/PelatihanMandiriPage/pages/TopicDetails'
import { NotFoundError } from 'utils/customError'
import useShowSocialDrawer from 'app/PelatihanMandiriPage/hooks/useShowSocialDrawer'
import { shouldHideNav } from 'app/PelatihanMandiriPage/helper'
import { WithLayoutListener } from 'components/Layout/Desktop/DesktopLayout'

const TopikPage = (props) => {
  const { isDesktopScreenSize } = props
  const router = useRouter()

  const shareText = useRef('')
  const { triggerShareDialog, Drawer } = useShowSocialDrawer({
    drawerTitle: 'Bagikan Topik',
    shareText: shareText.current,
  })
  const handlePageLoaded = useCallback((topicName?: string) => {
    shareText.current = `Ibu/Bapak Guru, ${
      !!topicName ? `ini topik ${topicName}` : 'ada topik pelatihan'
    } di platform Merdeka Mengajar. Silakan cek di tautan berikut: ${
      window.location.href
    }`
  }, [])
  return (
    <ErrorBoundary
      resetKeys={[router.asPath]}
      FallbackComponent={({ error, resetErrorBoundary }) => {
        if (
          error instanceof NotFoundError ||
          error instanceof JenjangUnmatched
        ) {
          return (
            <PelatihanErrorFallback
              error={error}
              resetErrorBoundary={resetErrorBoundary}
            />
          )
        } else {
          return (
            <CustomErrorFallback
              error={error}
              resetErrorBoundary={resetErrorBoundary}
            />
          )
        }
      }}
    >
      {!shouldHideNav() && (
        <HeaderBar fixed borderless className="z-10">
          <HeaderBarLeftAction
            icon={
              <Icon as="i" color="default">
                arrow_back
              </Icon>
            }
            onClick={() => historyUtils.backToApp(router.back)}
          />
          <HeaderBarRightAction onClick={triggerShareDialog}>
            <Icon>share</Icon>
          </HeaderBarRightAction>
        </HeaderBar>
      )}
      <WithLayoutListener isDesktop={isDesktopScreenSize}>
        <TopicDetails
          onPageLoaded={handlePageLoaded}
          isDesktop={isDesktopScreenSize}
        />
        <Drawer />
      </WithLayoutListener>
    </ErrorBoundary>
  )
}

TopikPage.layoutOpts = {
  hasHeader: false,
  className: clsx('bg-gray-10', !shouldHideNav() && 'mt-[54px]'),
  enableDesktopLayout: true,
}

export default TopikPage
